enum IV_PHOTO_SOURCE {
  appCamera = 'APP_CAMERA',
  nativeCamera = 'NATIVE_CAMERA',
  external = 'EXTERNAL',
}

export {IV_PHOTO_SOURCE};
